import React, { useState } from "react";
import { Form, Icon, Input, Button, Select, notification } from "antd";
import { getAccessTokenApi } from "../../../../api/auth";
import { addMenuApi } from "../../../../api/menu";
import "./AddMenuWebForm.scss";

export default function AddMenuWebForm(props) {
  const { setIsVisibleModal, setReloadMenuWeb } = props;
  const [menuWebData, setMenuWebData] = useState({});

  const addMenu = (event) => {
    event.preventDefault();

    let finalData = {
      title: menuWebData.title,
      url: (menuWebData.http ? menuWebData.http : "http://") + menuWebData.url,
    };
    //console.log(finalData);
    if (!finalData.title || !finalData.url || !menuWebData.url) {
      //si no tienen contenido
      notification["error"]({
        message: "Todos los campos son obligatorios.",
      });
    } else {
      const accessToken = getAccessTokenApi();
      finalData.active = false; //menu inactivo
      finalData.order = 1000; //final de todo los menus

      addMenuApi(accessToken, finalData)
        .then((response) => {
          notification["success"]({
            message: response,
          });
          setIsVisibleModal(false); //cierra el modal
          setReloadMenuWeb(true); //recargar el menu useEffect
          setMenuWebData({}); //limpiar formulario
          finalData = {}; //será un objeti
        })
        .catch(() => {
          notification["error"]({
            message: "Error en el servidor sdfsfsd.",
          });
        });
    }
  };

  return (
    <div className="add-menu-web-form">
      <AddForm
        menuWebData={menuWebData}
        setMenuWebData={setMenuWebData}
        addMenu={addMenu}
      />
    </div>
  );
}

function AddForm(props) {
  const { menuWebData, setMenuWebData, addMenu } = props;
  const { Option } = Select;

  const selectBefore = (
    <Select
      defaultValue="http://"
      style={{ width: 90 }}
      onChange={(event) => setMenuWebData({ ...menuWebData, http: event })}
    >
      <Option value="http://">http://</Option>
      <Option value="https://">https://</Option>
    </Select>
  );

  return (
    <Form className="form-add" onSubmit={addMenu}>
      <Form.Item>
        <Input
          prefix={<Icon type="font-size" />}
          placeholder="Titulo"
          value={menuWebData.title}
          onChange={(event) =>
            setMenuWebData({ ...menuWebData, title: event.target.value })
          }
        />
      </Form.Item>
      <Form.Item>
        <Input
          addonBefore={selectBefore}
          placeholder="URL"
          value={menuWebData.url}
          onChange={(event) =>
            setMenuWebData({ ...menuWebData, url: event.target.value })
          }
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" className="btn-submit">
          Crear menú
        </Button>
      </Form.Item>
    </Form>
  );
}
